
import { defineComponent } from "vue";
import MainImage from "@/components/home/MainImage.vue";
import QuickData from "@/components/home/QuickData.vue";

export default defineComponent({
  components: { QuickData, MainImage },
});
